export const ErrorMessage = ({errorMessage}: {errorMessage: string}) => (
  <div className="text-center pr-p-3" data-hpc>
    <div className="msg">
      <p>{errorMessage}</p>
    </div>
  </div>
)
